import React from 'react';

interface FilterChipsProps {
  topK: number;
  onTopKChange: (value: number) => void;
  onShowAdvancedFilters: () => void;
}

export const FilterChips: React.FC<FilterChipsProps> = ({
  topK,
  onTopKChange,
  onShowAdvancedFilters,
}) => {
  const topKOptions = [5, 10, 15, 20];

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <span className="text-sm text-gray-600">Resultados:</span>

      {topKOptions.map((value) => (
        <button
          key={value}
          onClick={() => onTopKChange(value)}
          className={`px-4 py-1.5 text-sm rounded-full border transition-colors ${
            topK === value
              ? 'bg-[#E8EFFE] text-[#0943B5] border-[#0943B5] font-medium'
              : 'bg-gray-50 text-gray-700 border-gray-300 hover:border-gray-400'
          }`}
        >
          Top {value}
        </button>
      ))}

      <button
        onClick={onShowAdvancedFilters}
        className="px-4 py-1.5 text-sm text-[#0943B5] hover:text-[#072d8a] font-medium"
      >
        + Más filtros
      </button>
    </div>
  );
};
